import { Stack } from '@mantine/core';
import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { NoContentPlaceholder } from '@/core/components';

import { HierarchyFacultySelect } from '@feature/utils';
import { useUniversityAdminHierarchy } from '@feature/utils/components/hooks/hierarchy/useHierarchy';

export function UniversityAdminResearchPerfEvalHeader() {
  const { userId, selectProps } = useUniversityAdminHierarchy();
  const { t } = useTranslation();

  return (
    <Stack>
      <HierarchyFacultySelect {...selectProps} />
      {userId == null && <NoContentPlaceholder title={t('hierarchySelectValidation.fromFaculties')} />}
      {userId != null && <Outlet />}
    </Stack>
  );
}
